module.exports = __webpack_public_path__ + "img/mastercard.cc10fc2f.svg";